import type { SidebarItemNode } from "./sidebar-config";
import { SIDEBAR_EMOJI_MAP } from "./sidebar-emoji-map";

export interface SidebarPageSearchResult {
  id: string;
  label: string;
  subtitle: string;
  emoji?: string;
  href: string;
}

export function fuzzyMatch(text: string, query: string): boolean {
  const target = text.toLowerCase();
  const needle = query.toLowerCase();
  if (!needle) return true;
  let queryIndex = 0;
  for (let index = 0; index < target.length && queryIndex < needle.length; index++) {
    if (target[index] === needle[queryIndex]) queryIndex++;
  }
  return queryIndex === needle.length;
}

export function getSidebarPageSearchResults(
  query: string,
  navItems: SidebarItemNode[],
): SidebarPageSearchResult[] {
  const normalizedQuery = query.toLowerCase();
  const flat: SidebarPageSearchResult[] = [];

  for (const item of navItems) {
    const emoji = item.builtInId
      ? SIDEBAR_EMOJI_MAP[item.builtInId]
      : SIDEBAR_EMOJI_MAP[item.href];
    if (!item.isHidden) {
      flat.push({
        id: "page-" + item.id,
        label: item.name,
        subtitle: item.href,
        emoji,
        href: item.href,
      });
    }

    for (const child of item.children) {
      const childEmoji = child.builtInId
        ? SIDEBAR_EMOJI_MAP[child.builtInId]
        : SIDEBAR_EMOJI_MAP[child.href];
      if (!child.isHidden) {
        flat.push({
          id: "page-" + child.id,
          label: child.name,
          subtitle: item.name + " › " + child.href,
          emoji: childEmoji,
          href: child.href,
        });
      }
    }
  }

  return flat
    .filter((page) => fuzzyMatch(page.label + " " + page.subtitle, normalizedQuery))
    .slice(0, 5);
}
